import { render, staticRenderFns } from "./AdditionalEntrance.vue?vue&type=template&id=efb1e228&scoped=true"
import script from "./AdditionalEntrance.vue?vue&type=script&lang=js"
export * from "./AdditionalEntrance.vue?vue&type=script&lang=js"
import style0 from "./AdditionalEntrance.vue?vue&type=style&index=0&id=efb1e228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb1e228",
  null
  
)

export default component.exports